"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const api_1 = __importDefault(require("./modules/api"));
const Authentication_1 = __importDefault(require("./modules/Authentication"));
const podio = {
    auth: (prop) => new Authentication_1.default(prop),
    api: api_1.default,
};
module.exports = podio;
